angular.module('impactx.rfx').controller('RFXOpenOfferCtrl', RFXOpenOfferCtrl);

RFXOpenOfferCtrl.$inject = ['$scope', 'dataGen','$mdDialog', 'TranslationService'];

function RFXOpenOfferCtrl($scope, dataGen, $mdDialog, TranslationService) {
    var ctrl = this;

    ctrl.requestInProgress = true;

    ctrl.trns = {
        openedOffers: TranslationService.get("openedOffers"),
        ok: TranslationService.get("ok")
    }


    ctrl.getData = function () {
        var paramObj = {
            rfqhId: ctrl.rfqhId
        };
        dataGen.getData($scope, paramObj, '/rfx/offers/openall').then(function () {
            ctrl.requestInProgress = false;
        });
    };

    ctrl.close = function () {
        $mdDialog.hide();
    }

    ctrl.getData();
}